import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch } from '../../../app/hooks';
import { getValueFromResource } from '../../../common/timeLiveFunction'
import { t } from "i18next";

interface PriorityMenuProps {
    onSelectPriority?: (priority: string) => void;
    selectedPriority?: string;
    prioritiesData?: any;
}

const PriorityMenu = ({ onSelectPriority, selectedPriority = 'Medium', prioritiesData }: PriorityMenuProps) => {
    const dispatch = useAppDispatch();

    return (
        <Dropdown.Menu
            className="menu menu-sub menu-sub-dropdown menu-column px-2 py-2 fs-7 w-200px rounded-3 shadow-sm"
            popperConfig={{
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            padding: 8
                        }
                    }
                ]
            }}
        >
            <Dropdown.Header>Task Priority</Dropdown.Header>
            {prioritiesData?.map((item: any, i: any) => (
                <React.Fragment key={i}>
                    <Dropdown.Item className="d-flex align-items-center gap-2 py-1" onClick={() => onSelectPriority?.(item)}>
                        <i
                            className="ki-solid ki-flag"
                            style={{
                                color: item.color,
                                fontSize: '14px'
                            }}
                        ></i>
                        <span className="text-gray-800 fw-semibold" style={{color: item.color}}>
                            {item.Priority}
                        </span>
                    </Dropdown.Item>
                    {i !== prioritiesData.length - 1 && (
                        <div className="separator mb-1 mt-1 opacity-75"></div>
                    )}
                </React.Fragment>
            ))}
        </Dropdown.Menu>
    );
};

export default PriorityMenu;
